// UI Toast functionality extracted from app.js
export function showToast(message, type = 'success') {
    const toast = document.getElementById('toast-container');
    const icon = document.getElementById('toast-icon');
    const text = document.getElementById('toast-message');

    text.innerText = message;
    
    // Set màu theo trạng thái (Xanh lá = success, Đỏ = error)
    toast.className = `fixed top-4 left-1/2 transform -translate-x-1/2 z-[100] w-11/12 max-w-sm p-4 rounded-xl shadow-2xl flex items-center space-x-3 transition-all duration-300 ${type === 'success' ? 'bg-income' : 'bg-expense'}`;
    icon.className = `fa-solid text-2xl text-white ${type === 'success' ? 'fa-circle-check' : 'fa-circle-exclamation'}`;

    // Hiệu ứng trượt xuống
    setTimeout(() => { 
        toast.classList.remove('-translate-y-20', 'opacity-0'); 
        toast.classList.add('translate-y-0', 'opacity-100'); 
    }, 10);

    // Tự động ẩn sau 3 giây
    setTimeout(() => {
        toast.classList.remove('translate-y-0', 'opacity-100');
        toast.classList.add('-translate-y-20', 'opacity-0');
    }, 3000);
}
